module.exports = __webpack_public_path__ + "media/חנוכה.af7a9bce.mp3";